import { OrganizationApplicationParameters } from '@platform/client/schemas';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ChallengeOneFormValues } from '../../../dashboard/org-business-challenges-form/ChallengeOne';
import BackgroundImage from '../../images/Margaret-Yebei.svg';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { challengeOptions } from '../../../dashboard/org-business-challenges-form/consts';

export const OrgFirstChallengeSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress, dataKey, isEditProfile = false } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>(dataKey);

  const defaultValues = {
    firstBusinessChallenge: getApplicationDataByKey('firstBusinessChallenge'),
    firstBusinessChallengeDescription: getApplicationDataByKey('firstBusinessChallengeDescription'),
  };

  const {
    handleSubmit,
    watch,
    control,
    formState: { errors },
  } = useForm<ChallengeOneFormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: defaultValues,
  });

  const onSubmit: SubmitHandler<ChallengeOneFormValues> = (data) => {
    updateApplicationData({
      firstBusinessChallenge: data.firstBusinessChallenge ?? undefined,
      firstBusinessChallengeDescription: data.firstBusinessChallengeDescription ?? undefined,
    });
    onContinue();
  };

  const handleOnBack = () => {
    updateApplicationData({
      firstBusinessChallenge: watch('firstBusinessChallenge') ?? undefined,
      firstBusinessChallengeDescription: watch('firstBusinessChallengeDescription') ?? undefined,
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleOnBack}
      onSubmit={() => handleSubmit(onSubmit)()}
      backgroundImage={BackgroundImage}
      isEditProfile={isEditProfile}
    >
      <ApplicationPageContent
        title="Tell us about the challenges you're working through"
        description={
          'Start with your most important challenge. You can add more challenges later. This helps us connect you with the right skills and expertise.'
        }
      >
        <FormsInputDropdown
          control={control}
          name='firstBusinessChallenge'
          rules={{ required: 'Select a challenge your organization needs help with to continue' }}
          label='Select a challenge area'
          placeholder='Select one'
          items={challengeOptions}
          type='default'
          error={errors.firstBusinessChallenge}
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'firstBusinessChallengeDescription'}
          rules={{ maxLength: 500, required: 'Tell us more about this challenge to continue' }}
          formsError={errors.firstBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
